// extracted by mini-css-extract-plugin
export var typingIndicator = "_ke-0";